import apiService from "./api.service";
import authService from "./auth.service";
import { logout } from "../helpers/logout";

const getAll = async ({
  target,
  start_date_from,
  start_date_to,
  per_page,
  page,
  role,
  type,
}) => {
  const userToken = await authService.getAuthToken();
  return fetch(
    apiService.getEndpointbyRole(role, "NOTIFICATIONS") +
      `?target=${target}&start_date_to=${start_date_to}&start_date_from=${start_date_from}&page=${page}&per_page=${per_page}&type=${type}`,
    {
      method: "GET",
      headers: {
        Authorization: userToken,
      },
    }
  )
    .then((response) => response.json())
    .catch((err) => {
      logout(err);
    });
};

const getAllActives = async (role) => {
  const userToken = await authService.getAuthToken();
  return fetch(apiService.getEndpointbyRole(role, "NOTIFICATIONS"), {
    method: "GET",
    headers: {
      Authorization: userToken,
    },
  })
    .then((response) => response.json())
    .catch((err) => {
      logout(err);
    });
};

const insert = async (notification, role) => {
  const userToken = await authService.getAuthToken();
  return fetch(apiService.getEndpointbyRole(role, "NOTIFICATIONS"), {
    method: "POST",
    headers: {
      Authorization: userToken,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(notification),
  })
    .then((response) => response.json())
    .catch((err) => {
      logout(err);
    });
};

const getById = async (id_notification, type) => {
  const userToken = await authService.getAuthToken();

  let url =  apiService.getEndpoint("NOTIFICATIONS") +
      `/${id_notification}`;
  
  if (type) {
    url += `?type=${type}`;
  }

  return fetch(url, {
      method: "GET",
      headers: {
        Authorization: userToken,
      },
    }
  )
    .then((response) => response.json())
    .then((data) => data)
    .catch((err) => {});
};

const update = async ({ canceled_notification }) => {
  const userToken = await authService.getAuthToken();
  return fetch(apiService.getEndpoint("NOTIFICATIONS"), {
    method: "PUT",
    headers: {
      Authorization: userToken,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(canceled_notification),
  })
    .then((response) => response.json())
    .catch((err) => {
      logout(err);
    });
};

const notificationsService = {
  getAll,
  getAllActives,
  insert,
  getById,
  update,
};

export default notificationsService;
